import posthog from 'posthog-js'
import { init as initSentry, BrowserTracing, Replay } from '@sentry/react'

export const setSentry = ({
  dsn,
  environment,
  version,
  projectId,
  organization,
}) => {
  // NOTE: Only enable Sentry in production and preview environments
  if (
    process.env.CONFIG_ENV !== 'production' &&
    process.env.CONFIG_ENV !== 'preview'
  ) {
    return
  }

  if (!dsn) {
    return
  }

  // Initialize Sentry
  initSentry({
    dsn,
    environment,
    release: version,
    integrations: [
      new BrowserTracing(),
      new Replay(),
      ...(projectId
        ? [new posthog.SentryIntegration(posthog, organization, projectId)]
        : []),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1,
    // Session Replay: https://docs.sentry.io/platforms/javascript/session-replay/understanding-sessions/#default-session-initialization
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1,
  })
}
